import { useCart } from '../CartProvider/CartProvider'
import { AutocompleteMerchant } from './AutocompleteMerchant'

export const MerchantSelector = () => {
  const { projectCode, countryCode, campaignCodeFromUrl, campaignId } = useCart()

  return (
    <AutocompleteMerchant
      projectCode={projectCode}
      countryCode={countryCode}
      campaignCode={campaignCodeFromUrl}
      campaignId={campaignId}
    />
  )
}
